const CONNEXION = {
  identifiant: 'Identifiant',
  mdp: 'Mot de passe',
  site: 'Site',
  nouveauMdp: 'Nouveau mot de passe',
  nouveauMdpConfirmation: 'Confirmation nouveau mot de passe',
  actions: {
    connexion: 'Connexion',
    mdpOublie: 'Mot de passe oublié ?',
    reinitialiser: 'Réinitialiser',
  },
  info: {
    siteOptimise: 'Affixe 2.0 est optimisé pour les versions récentes des navigateurs Firefox, Safari et Chrome.',
    changeNavigateur: 'Veuillez changer de navigateur',
    produit: 'Solution créée et éditée par Quadra-Diffusion',
    connexionSupportAffixe1: 'Merci de ne plus vous connecter avec le compte support.',
    connexionAffixe1: 'Merci de ne plus vous connecter avec une adresse mail (affixe1) mais avec votre nom d\'utilisateur Affixe2.',
    infoConnexionPortail: 'Vous n\'êtes pas autorisé à vous connecter à affixe.',
  },
  error: {
    infoIncorrect: 'Nom d\'utilisateur ou mot de passe non valide.',
    blocked: 'Utilisateur bloqué, veuillez contacter l\'assistance.',
    userInactif: 'Utilisateur inactif, veuillez contacter l\'assistance.',
  },
  required: {
    mdp: 'Mot de passe',
    identifiant: 'Identifiant',
    secondaryUserNameOrEmailAddress: 'Utilisateur',
  },
  popupMdpOublie: {
    email: 'Email',
    site: 'Site',
    envoyer: 'Envoyer',
    cancel: 'Annuler',
    required: {
      email: 'Email',
      site: 'Site',
    },
    info: {
      success: 'Un email vous a été envoyé',
    },
    error: {
      noEmailRegistered: 'Email non reconnu, veuillez contacter votre admin',
      userNotFound: 'Utilisateur non trouvé',
      tenantNotFound: 'Site indisponible',
      invalidCode: 'Code de reinitialisation invalide ou expiré',
      passwordRequired: 'Mot de passe requis',
    },
  },
  resetPassword: {
    title: 'Réinitialisation du mot de passe',
    success: 'Votre mot de passe a été réinitialisé',
    error: {
      password: 'Le mot de passe doit contenir au moins 6 caractères',
    },
  },
};

export default CONNEXION;
